import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { SelectMenuAppearance } from "../models/select-menu-apearance";

// tslint:disable-next-line:interface-name
export interface SelectMenuOption {
  key: string;
  text: string;
  icon?: string;
  customValue: any;
}

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectMenuComponent),
  multi: true,
};

@Component({
  selector: "select-menu",
  templateUrl: "./select-menu.component.html",
  styleUrls: ["./select-menu.component.scss"],
  animations: [
    trigger("transformMenu", [
      state(
        "void",
        style({
          opacity: 0,
          transform: "scale(0.8)",
        })
      ),
      transition(
        "void => enter",
        animate(
          "120ms cubic-bezier(0, 0, 0.2, 1)",
          style({
            opacity: 1,
            transform: "scale(1)",
          })
        )
      ),
      transition(
        "* => void",
        animate("100ms 25ms linear", style({ opacity: 0 }))
      ),
    ]),
  ],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class SelectMenuComponent implements OnInit {
  @Input("menuOptions") public menuOptions: SelectMenuOption[];
  @Input("appearance") public appearance: SelectMenuAppearance = "";
  @Input("length") public length: number;
  @Input("disabled") public disabled: boolean = false;
  @ViewChild("componentMain") public componentMain: ElementRef;
  @Output("select-menu-event")
  public menuEvent: EventEmitter<SelectMenuOption> = new EventEmitter<SelectMenuOption>();

  public menuIsOpen: boolean = false;
  public selectedOption: SelectMenuOption = {
    text: "בחר מתוך הרשימה",
    key: "",
    icon: "",
    customValue: null,
  };

  public clickedOption($event: MouseEvent, key: string) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    this.selectedOption = this.menuOptions.find((o) => o.key === key);
    this.menuEvent.emit(this.selectedOption);
    this.onTouchedCallback();
    this.onChangeCallback(this.selectedOption);
    this.closeMenu();
  }

  public toggleMenu($event) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    if (this.disabled) {
      return;
    }
    this.menuIsOpen = !this.menuIsOpen;
    if (!this.menuIsOpen) {
      this.closeMenu();
      return;
    }
    setTimeout(() => {
      // this will make the execution after the above boolean has changed
      this.componentMain.nativeElement.focus();
    }, 10);
  }

  public closeMenu() {
    this.menuIsOpen = false;
  }

  public onTouchedCallback: () => void = () => {};

  public onChangeCallback: (_: any) => void = () => {};

  //From ControlValueAccessor interface

  public ngOnInit(): void {
    this.selectedOption =
      this.menuOptions && this.menuOptions[0]
        ? this.menuOptions[0]
        : this.selectedOption;
  }

  public menuKeyDown($event: KeyboardEvent) {
    if ($event.code === "Delete") {
      $event.stopPropagation();
      $event.stopImmediatePropagation();
      this.selectedOption = null;
      this.menuEvent.emit(this.selectedOption);
      this.onTouchedCallback();
      this.onChangeCallback(this.selectedOption);
      this.closeMenu();
    }
  }

  //From ControlValueAccessor interface
  private registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  private registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  private writeValue(value: SelectMenuOption) {
    this.selectedOption = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/form/select-menu/select-menu.component.ts